<template>
  <div class="resume-module-manager">
    <div class="module-title">
      <div class="m-l">
        <img class="icon" src="../../assets/img/bookmark-one.png" alt="">
        <div class="title">技能语言</div>
      </div>
      <div class="m-r">
        <img @click="handleAdd" class="add-icon" src="../../assets/img/Add.png" alt="">
      </div>
    </div>
    <div class="data-wrap" v-if="dataList.length && !detailShow">
      <div class="wrap-item data-item-wrap" v-for="item in dataList" :key="item.id">
        <div class="action">
          <img @click="handleEdit(item)" class="edit-icon" src="../../assets/img/edit.png" alt="">
          <img @click="handleDelete(item.id)" class="delete-icon" src="../../assets/img/delete.png" alt="">
        </div>
        <div class="content-wrap">
          <div class="main-info">
            <div class="name">{{ item.skill_name || '未填写' }}</div>
          </div>
          <div class="sub-info">
            <div class="sub-item">
              分数/等级：{{ item.score_level || '未填写' }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="data-form-wrap" v-if="detailShow">
      <div class="title">{{ form.id ? '编辑技能' : '添加技能' }}</div>
      <el-form :model="form" ref="formRef" :rules="rules" label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="技能名称" prop="skill_name">
              <el-input clearable class="w100" v-model="form.skill_name" placeholder="请填写技能名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="分数/等级" prop="score_level">
              <el-input clearable class="w100" v-model="form.score_level" placeholder="请填写分数/等级"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="footer">
        <el-button size="small" class="cancel-btn" @click="handleCancel">取消</el-button>
        <el-button size="small" class="save-btn" type="primary" @click="handleSave">保存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Education',
  props: {
    dataList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      detailShow: false,
      form: {
        id: '',
        skill_name: '',
        score_level: '',
      },
      rules: {  
        skill_name: [{ required: true, message: '请填写技能名称', trigger: 'blur' }],
        score_level: [{ required: true, message: '请填写技能等级', trigger: 'blur' }],
      }
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return '--'
      // 只返回年月日部分
      return date.split(' ')[0] || date
    },
    handleAdd() {
      this.detailShow = true;
      this.form = {
        id: '',
        skill_name: '',
        score_level: '',
      }
    },
    handleEdit(item) {
      this.detailShow = true;
      this.form = item;
    },
    handleDelete(id) {
      this.$confirm('确定删除该学术经历吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$emit('delete', id);
      });
    },
    handleCancel() {
      this.$confirm('确定取消编辑吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.detailShow = false;
        this.$refs.formRef.resetFields();
      });
    },
    handleSave() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.$emit('save', {
            ...this.form,
          });
          this.detailShow = false;
          this.$refs.formRef.resetFields();
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">
.w100 {
  width: 100% !important;
}

.resume-module-manager {
  padding: 18px 0 18px 12px;
  border-bottom: 1px dashed #B16EF9;

  .module-title {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .m-l {
      display: flex;
      align-items: center;

      .icon {
        width: 26px;
        height: 26px;
        margin-right: 12px;
      }

      .title {
        font-size: 20px;
        font-weight: 600;
        color: #656587;
      }
    }

    .m-r {
      cursor: pointer;
      display: flex;
      width: 24px;
      height: 24px;

      .add-icon {
        width: 100%;
        height: 100%;
      }

      &:hover {
        opacity: 0.8;
      }
    }
  }

  .data-wrap {
    margin-top: 16px;

    .wrap-item {
      cursor: pointer;
      padding-left: 36px;
      padding-top: 8px;
      padding-bottom: 8px;
      border-radius: 12px;

      &:hover {
        background: linear-gradient(0deg, rgba(152, 152, 152, 0.03), rgba(152, 152, 152, 0.03)), #FFFFFF;
      }

      .action {
        display: flex;
        justify-content: flex-end;
        padding-right: 5px;

        .delete-icon,
        .edit-icon {
          cursor: pointer;
          width: 16px;

          &:hover {
            opacity: .8;
          }
        }

        .edit-icon {
          margin-right: 8px;
        }
      }

      .content-wrap {
        .main-info {
            display: flex;
            align-items: center;
            flex-wrap: wrap;

            .name {
              min-width: 200px;
              margin-right: 32px;
              font-size: 20px;
              font-weight: 600;
              color: #000000;
              margin-bottom: 8px;
            }

            .period {
              display: flex;
              align-items: center;
              font-size: 16px;
              color: #656587;
              margin-bottom: 8px;
            }
          }

          .sub-info {
            display: flex;
            align-items: center;
            flex-wrap: wrap;

            .sub-item {
              width: 100%;
              font-size: 14px;
              color: #656587;
              line-height: 20px;
              margin-right: 20px;
            }
          }
      }
    }
  }

  .data-form-wrap {
    margin-top: 16px;
    padding: 16px 16px 16px 36px;
    border-radius: 12px;
    // background: #fcfcfc;
    background: linear-gradient(0deg, rgba(152, 152, 152, 0.03), rgba(152, 152, 152, 0.03)), #FFFFFF;

    .title {
      margin-bottom: 16px;
      font-size: 16px;
      font-weight: 600;
      color: #656587;
    }

    .date-picker-wrap {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .footer {
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>